import React, { useState } from "react";
import order_img from "../../assets/images/product/Display image D.png";
import van_icon from "../../assets/profile/van_icon.png";
import OrdersOffCanvas from "./OrdersOffCanvas";
const Orders = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [action, setAction] = useState("");
  const [productId, setProductId] = useState(null);
  const handleOpen = (type, id) => {
    setAction(type);
    setProductId(id);
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
    setAction("");
    setProductId(null);
  };
  return (
    <>
      <div className="bg-white md:p-6 p-3 flex flex-col gap-5 rounded-[10px]">
        <div className="flex flex-row sm:flex-col sm:gap-3 gap-4  items-center font-lexend">
          <div className="sm:w-full">
            <img
              src={order_img}
              alt=""
              className=" w-40 h-40 sm:w-full sm:h-full  rounded-[10px]"
            />
          </div>
          <div className="flex flex-col sm:w-full  justify-between items-baseline gap-0.5">
            <h2 className="md:text-[22px] sm:text-base text-xl font-semibold ">
              Ortho Latex Mattress
            </h2>
            <p className="text-base sm:text-sm font-semibold text-[#6d6d6d]">
              Single, 72x72 Inch, 6 Inch
            </p>

            <p className="text-base sm:text-sm font-semibold text-[#6d6d6d]">Qty: 1</p>
            <p className="text-xl sm:text-lg font-semibold text-[#2a552f]">₹44,480</p>
            <div className="flex items-center justify-center bg-[#f5f2e1] py-1.5 px-2 w-full gap-4 3xl:w-80 rounded-lg 3xl:gap-3">
              <img src={van_icon} alt="" />
              <p className=" 3xl:text-sm text-xs">
                Expected Delivery:{" "}
                <span className="font-semibold text-[#2a552f]">
                  30 Dec 2025
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="grid sm:grid-cols-1 grid-cols-2 md:text-lg text-base sm:text-sm font-lexend sm:gap-2 gap-1">
          <div className="flex flex-col sm:py-2 py-6 sm:rounded-[10px] rounded-l-[10px] justify-center items-center bg-[#e9f6e8]">
            <div className="text-center">
              <p className="font-light">Order number</p>
              <p className="font-semibold">ORD 784038</p>
            </div>
          </div>
          <div className="flex flex-col justify-center sm:rounded-[10px] sm:py-2 py-6 rounded-r-[10px] items-center bg-[#e9f6e8]">
            <div className="text-center">
              <p className="font-light">Order placed on</p>
              <p className="font-semibold">26 December 2025</p>
            </div>
          </div>
        </div>
        <button
          onClick={() => handleOpen("details", "ORD123")}
          className={`bg-[#2a552f] cursor-pointer w-full flex justify-center items-center gap-3 text-[#f4e390] font-semibold sm:text-base text-xl font-lexend py-2  text-center rounded-lg`}
        >
          View order details
        </button>
      </div>
      <div className="bg-white md:p-6 p-3 mt-5 flex flex-col gap-5 rounded-[10px]">
        <div className="flex flex-row sm:flex-col sm:gap-3 gap-4  items-center font-lexend">
          <div className="sm:w-full">
            <img
              src={order_img}
              alt=""
              className=" w-40 h-40 sm:w-full sm:h-full  rounded-[10px]"
            />
          </div>
          <div className="flex flex-col sm:w-full  justify-between items-baseline gap-0.5">
            <h2 className="md:text-[22px] sm:text-base text-xl font-semibold ">
              Ortho Latex Mattress
            </h2>
            <p className="text-base sm:text-sm font-semibold text-[#6d6d6d]">
              Single, 72x72 Inch, 6 Inch
            </p>

            <p className="text-base sm:text-sm font-semibold text-[#6d6d6d]">Qty: 1</p>
            <p className="text-xl sm:text-lg font-semibold text-[#2a552f]">₹44,480</p>
            <div className="flex items-center justify-center bg-[#f5f2e1] py-1.5 px-4 gap-4 rounded-lg 3xl:gap-3">
              <p className=" 3xl:text-sm text-xs">
                Delivered:{" "}
                <span className="font-semibold text-[#2a552f]">
                  30 Dec 2025
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="grid sm:grid-cols-1 grid-cols-2 md:text-lg text-base sm:text-sm font-lexend sm:gap-2 gap-1">
          <div className="flex flex-col sm:py-2 py-6 sm:rounded-[10px] rounded-l-[10px] justify-center items-center bg-[#e9f6e8]">
            <div className="text-center">
              <p className="font-light">Order number</p>
              <p className="font-semibold">ORD 784038</p>
            </div>
          </div>
          <div className="flex flex-col justify-center sm:rounded-[10px] sm:py-2 py-6 rounded-r-[10px] items-center bg-[#e9f6e8]">
            <div className="text-center">
              <p className="font-light">Order placed on</p>
              <p className="font-semibold">26 December 2025</p>
            </div>
          </div>
        </div>
        <div className="grid xs:grid-cols-1 grid-cols-2 gap-2">
          <button
            className={`border-[#2a552f] border cursor-pointer flex justify-center items-center gap-3 text-[#2a552f] font-semibold sm:text-base text-xl font-lexend py-2 w-full rounded-lg`}
          >
            Download invoice
          </button>
          <button
            onClick={() => handleOpen("return", "ORD123")}
            className={`bg-[#2a552f] cursor-pointer flex justify-center text-wrap items-center gap-3 text-[#f4e390] font-semibold sm:text-base text-xl font-lexend py-2 w-full rounded-lg`}
          >
            Return/Exchange
          </button>
        </div>
      </div>
      <div className="bg-white md:p-6 p-3 mt-5 flex flex-col gap-5  border-[#dc0202] border-2 rounded-[10px]">
        <div className="flex flex-row sm:flex-col sm:gap-3 gap-4  items-center font-lexend">
          <div className="sm:w-full">
            <img
              src={order_img}
              alt=""
              className=" w-40 h-40 sm:w-full sm:h-full  rounded-[10px]"
            />
          </div>
          <div className="flex flex-col sm:w-full  justify-between items-baseline gap-0.5">
            <h2 className="md:text-[22px] sm:text-base text-xl font-semibold ">
              Ortho Latex Mattress
            </h2>
            <p className="text-base sm:text-sm font-semibold text-[#6d6d6d]">
              Single, 72x72 Inch, 6 Inch
            </p>

            <p className="text-base sm:text-sm font-semibold text-[#6d6d6d]">Qty: 1</p>
            <p className="text-xl sm:text-lg font-semibold text-[#2a552f]">₹44,480</p>
            <div className="flex items-center justify-center bg-[#f5f2e1] py-1.5 px-4 gap-4 rounded-lg 3xl:gap-3">
              <p className=" 3xl:text-sm text-xs">
                Delivered:{" "}
                <span className="font-semibold text-[#2a552f]">
                  30 Dec 2025
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="grid sm:grid-cols-1 grid-cols-2 md:text-lg text-base sm:text-sm font-lexend sm:gap-2 gap-1">
          <div className="flex flex-col sm:py-2 py-6 sm:rounded-[10px] rounded-l-[10px] justify-center items-center bg-[#e9f6e8]">
            <div className="text-center">
              <p className="font-light">Order number</p>
              <p className="font-semibold">ORD 784038</p>
            </div>
          </div>
          <div className="flex flex-col justify-center sm:rounded-[10px] sm:py-2 py-6 rounded-r-[10px] items-center bg-[#e9f6e8]">
            <div className="text-center">
              <p className="font-light">Order placed on</p>
              <p className="font-semibold">26 December 2025</p>
            </div>
          </div>
        </div>
        <div className="grid xs:grid-cols-1 grid-cols-2 gap-2">
          <button
            className={`border-[#2a552f] border cursor-pointer flex justify-center items-center gap-3 text-[#2a552f] font-semibold sm:text-base text-xl font-lexend py-2 w-full rounded-lg`}
          >
            Download invoice
          </button>
          <button
            onClick={() => handleOpen("trackreturn", "ORD123")}
            className={`bg-[#f50633] cursor-pointer flex justify-center items-center gap-3 text-[#fff] font-semibold sm:text-base text-xl font-lexend py-2 w-full rounded-lg`}
          >
            Track return
          </button>
        </div>
      </div>
      <OrdersOffCanvas
        isOpen={isOpen}
        onClose={handleClose}
        action={action}
        productId={productId}
      />
    </>
  );
};

export default Orders;
